import { Link } from 'react-router-dom';
import EarningsDisclaimer from '@/components/EarningsDisclaimer';

const SiteFooter = () => {
  return (
    <footer className="relative mt-4" data-testid="site-footer">
      {/* Earnings & Risk Disclaimer — appears above the main footer row */}
      <EarningsDisclaimer />

      <div className="border-t border-[rgba(255,182,18,0.10)]">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-xl flex items-center justify-center bg-gradient-to-br from-[#FFC20E] to-[#FFB612]">
              <span className="text-[#0a0a0b] font-black font-display text-sm">1S</span>
            </div>
            <div className="leading-tight">
              <div className="font-display font-bold text-[14px]">
                1SimpleCycler <span className="sc-gold-text">3.0</span>
              </div>
              <div className="text-[10px] uppercase tracking-[0.22em] text-[var(--sc-text-mute)]">1simplecycler3.com</div>
            </div>
          </div>

          <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-[12px] text-[var(--sc-text-mute)]">
            <a href="#why" className="hover:text-[#FFC20E] transition">
              Why 3.0
            </a>
            <a href="#how" className="hover:text-[#FFC20E] transition">
              How It Works
            </a>
            <a href="#built-for-you" className="hover:text-[#FFC20E] transition">
              Built For You
            </a>
            <a href="#assets" className="hover:text-[#FFC20E] transition">
              Assets
            </a>
            <Link to="/login" className="hover:text-[#FFC20E] transition">
              Login
            </Link>
          </div>

          <div className="text-[11px] uppercase tracking-[0.22em] text-[var(--sc-text-mute)]">
            © {new Date().getFullYear()} 1SimpleCycler 3.0 · Hybrid Rotator Architecture
          </div>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
